import { render } from "./ProductAdvantages.vue?vue&type=template&id=4f179b0e"
import script from "./ProductAdvantages.vue?vue&type=script&lang=js"
export * from "./ProductAdvantages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__